// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qrcode-wrapper {\n  text-align: center;\n}\n.qrcode-wrapper .twofa-qrcode {\n  display: inline-block;\n  margin: 30px auto 30px auto;\n}\n.twofa-secret {\n  color: #182eaa;\n}\n.bind-tip {\n  padding-left: 20px;\n  font-weight: bold;\n}", ""]);
// Exports
module.exports = exports;
